import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { TextField } from '@material-ui/core';

export interface Props {
  value?: string;
  defaultValue?: number;
  label?: string;
  onChange?: (value: number | null) => void;
  [k: string]: any;
  shape?: (value: number) => number;
}

const NumberInput = ({ value, defaultValue, label, onChange, shape, ...rest }: Props) => {
  const translate = useTranslate();
  const [state, setState] = useState<any>(value);

  useEffect(() => {
    setState(value);
  }, [value]);

  const handleBlur = () => {
    let actualValue: number = 0;
    if (state) {
      const value = parseFloat(state + '');
      actualValue = isNaN(value) ? 0 : value;
    } else if (typeof defaultValue !== 'undefined') {
      actualValue = defaultValue;
    }
    const shapedValue = shape ? shape(actualValue) : actualValue;
    setState(shapedValue + '');
    onChange && onChange(shapedValue);
  };
  return (
    <div>
      <TextField
        {...rest}
        label={label && translate(label)}
        type='number'
        value={state + ''}
        defaultValue={defaultValue}
        onChange={(e: any) => {
          setState(e.target.value);
        }}
        onBlur={handleBlur}
        onClick={handleBlur} // hacky way to trigger blur on step-button click
      />
    </div>
  );
};

export default NumberInput;
